import React from 'react';
import { Loader } from '@vds/loaders';
import './LoadingFallback.css';

/**
 * Loading fallback component for React.lazy() Suspense boundaries
 * Used during code splitting to show loading state while chunks load
 */
export const LoadingFallback = ({ message = 'Loading...' }) => {
  return (
    <div className="loading-fallback">
      <Loader active={true} />
      <p className="loading-message">{message}</p>
    </div>
  );
};

/**
 * Page-level loading fallback
 * Used for route-based code splitting
 */
export const PageLoadingFallback = () => {
  return <LoadingFallback message="Loading page..." />;
};

/**
 * Component-level loading fallback
 * Used for feature-based code splitting (charts, editors, etc.)
 */
export const ComponentLoadingFallback = () => {
  return (
    <div className="component-loading-fallback">
      <Loader active={true} />
    </div>
  );
};

export default LoadingFallback;
